import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {ReactNode} from 'react';
import {Redirect} from 'react-router-dom';
import {getUserClaims} from 'Shared/utilities/UserProfileUtilities';
import {UserClaims} from 'Users/models/Claims';

type WithClaimsProps = {
  children: (claims: UserClaims) => ReactNode;
};

const WithClaims = ({children}: WithClaimsProps) => {
  const claimsOption = getUserClaims();

  return pipe(
    claimsOption,
    O.fold(
      () => <Redirect to="/noAccess" />,
      claims => <>{children(claims)}</>
    )
  );
};

export default WithClaims;
